module.exports = __webpack_public_path__ + "static/img/hot_icon@2x.95b611cb.png";